import type { ReactNode } from 'react';

/**
 * The Discord status bubble: a small dot pinned to the bottom-right of an
 * avatar. The ring is drawn in the surrounding background colour so the dot
 * looks punched out of the avatar rather than laid on top of it — pass the
 * matching `ring` class when the backdrop isn't the sidebar/panel default.
 */
export function PresenceDot({
  online,
  className = '',
  ringClassName = 'ring-sidebar',
}: {
  online: boolean;
  className?: string;
  ringClassName?: string;
}) {
  return (
    <span
      aria-hidden="true"
      className={`block h-2.5 w-2.5 rounded-full ring-2 ${ringClassName} ${
        online ? 'bg-emerald-500' : 'bg-muted-foreground/50'
      } ${className}`}
    />
  );
}

/** Avatar + status dot as one unit, so callers don't repeat the positioning. */
export function AvatarWithPresence({
  children,
  online,
  ringClassName,
}: {
  children: ReactNode;
  online: boolean;
  ringClassName?: string;
}) {
  return (
    <span className="relative shrink-0">
      {children}
      <PresenceDot
        online={online}
        ringClassName={ringClassName}
        className="absolute -bottom-0.5 -right-0.5"
      />
    </span>
  );
}
